<template>
  <div class="rangeSliderDiv me-4 justify-content-center d-flex align-items-center flex-row-reverse" >
    <vue-slider ref="slider" v-model="modelValue" v-bind="options" @drag-end="RateValue(modelValue)"></vue-slider>
    <span style="white-space: nowrap; margin-left: 10px">{{ options.text }}</span>
  </div>
</template>

<script>
import VueRangeSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'

export default {
  components: {
    vueSlider: VueRangeSlider,
  },

  props: {
    modelValue: {
      type: Number,
      default: 0,
    },
    options: {
      text: {
        type: String,
        default: 'رضایت از مشتری',
      },
      dotSize: {
        type: Number,
        default: 0,
      },
      width: {
        type: String,
        default: '100%',
      },
      height: {
        type: Number,
        default: 0,
      },
      contained: {
        type: Boolean,
        default: false,
      },
      direction: {
        type: String,
        default: 'rtl',
      },
      data: {
        type: Array,
        default: null,
      },
      dataLabel: {
        type: String,
        default: 'label',
      },
      dataValue: {
        type: String,
        default: 'value',
      },
      min: {
        type: Number,
        default: 0,
      },
      max: {
        type: Number,
        default: 10,
      },
      interval: {
        type: Number,
        default: 1,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      clickable: {
        type: Boolean,
        default: true,
      },
      duration: {
        type: Number,
        default: 1,
      },
      adsorb: {
        type: Boolean,
        default: false,
      },
      lazy: {
        type: Boolean,
        default: true,
      },
      tooltip: {
        type: String,
        default: 'always',
      },
      tooltipPlacement: {
        type: String,
        default: 'top',
      },
      tooltipFormatter: {
        default: null,
      },
      useKeyboard: {
        type: Boolean,
        default: false,
      },
      keydownHook: null,
      dragOnClick: {
        type: Boolean,
        default: true,
      },
      enableCross: {
        type: Boolean,
        default: true,
      },
      fixed: {
        type: Boolean,
        default: false,
      },
      minRange: {
        default: null,
      },
      maxRange: {
        default: null,
      },
      order: {
        type: Boolean,
        default: true,
      },
      marks: {
        type: Object,
        default: {
          '0': '0',
          '10': '10',
        },
      },
      dotOptions: {
        default: null,
      },
      dotAttrs: {
        default: null,
      },
      process: {
        type: Boolean,
        default: true,
      },
      dotStyle: {
        default: null,
      },
      railStyle: {
        default: null,
      },
      processStyle: {
        type: Object,
        default: { backgroundColor: '#556ee6' },
      },
      tooltipStyle: {
        type: Object,
        default: { backgroundColor: '#556ee6', borderColor: '#556ee6', height: '25px', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2px 1px' },
      },
      stepStyle: {
        default: null,
      },
      stepActiveStyle: {
        default: null,
      },
      labelStyle: {
        default: null,
      },
      labelActiveStyle: {
        default: null,
      },
    },
  },
  methods: {
    RateValue() {
      this.$emit('rate', this.modelValue)
    },
  },
}
</script>

<style scoped>
.p-card {
  background-color: transparent !important;
}
#wrap {
  padding: 0 !important;
}
.labelsMinMax {
  display: flex;
  justify-content: space-between;
}
.p-card-body {
  padding: 0 !important ;
}
</style>
